import Axios from 'axios';
import URL from '../../config/url';
import {toast} from '../../base-components/StudioToast';
import {useEffect, useState} from 'react';

import {Info} from '../metadata/Info';

export type ApplicationDetails = Info & {
  ownerId: string;
  supportsSinglePageApplications: boolean;
};

type ApplicationDetailsResponse = {
  body: ApplicationDetails;
  errors: [];
};

export const useApplicationDetails = (applicationId: string) => {
  const [applicationDetails, setApplicationDetails] = useState<ApplicationDetails>();

  useEffect(() => {
    async function fetchApplicationDetails() {
      const {data: detailsResponse} = await Axios.get<ApplicationDetailsResponse>(
        URL.APPLICATION_DETAILS(applicationId)
      );
      if (
        detailsResponse &&
        detailsResponse.errors &&
        detailsResponse.errors?.length > 0
      ) {
        toast.error(detailsResponse.errors);
        setApplicationDetails(undefined);
      } else {
        setApplicationDetails(detailsResponse.body);
      }
    }

    if (applicationId) {
      fetchApplicationDetails();
    }
  }, [applicationId]);

  return applicationDetails;
};
